/*
 * src/components/TransferHistory/TransferHistory.jsx
 * Description: Listing out transfers
 * Copyright (c) 2021 PredictiveUX
 */
import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import get from 'lodash/get';
import map from 'lodash/map';
import size from 'lodash/size';
import { PaymintsIconButton } from 'paymints-address-autocomplete-field';
import BoxContainer from '../BoxContainer/BoxContainer';
import {
  useClientByPhone,
  useAllClientDocuments,
} from '../../utils/service/service_user_api';
import AlertBanner from '../AlertBanner/';
import { useAllTransfersSorted } from '../../hooks/useAllTransfersSorted';
// import  useAllTransferArchives  from '../../hooks/useAllTransferArchives';
import { useInstitutionLogoOR } from '../../utils/service/service_institution_logo';
import ContentModal from '../ContentModal/ContentModal';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';
import { getClientStore } from '../../utils/util';

import TransferHistoryListing from './TransferHistoryListing';
import MobileHistory from './MobileHistory/MobileHistory';
import './transferHistory.css';

const buildCancelEditError = () => (
  <div className="transfer-history__modal">
    <div className="transfer-history__modal-info">
      The transfer cannot be edited
    </div>
  </div>
);

/**
 * The primary component
 * @param {*} props
 * @returns
 */
const TransferHistory = props => {
  // local state
  const [seeMoreInfo, updateSeeMoreInfo] = useState([]);

  const [transfers, setTransfers]= useState([])
  // get client information
  const { user } = getClientStore();
  const { loadingSearch, client } = useClientByPhone(user?.mobilePhone || null);
  const clientID = get(client, 'id');

  // retrieve transfer information

  const {
    loadingSearchTransfer,
    transfers: transfersNew,
    refetchTransfers,
  } = useAllTransfersSorted(clientID);

  // retrieve transfer archive information

  // const {
  //   transfers: transfersArchive,
  //   loadingTransfersArchive
  // } = useAllTransferArchives();

  
  

  // retrieve client documentation
  const { clientDocuments } = useAllClientDocuments(clientID);

  // unique list of bank accounts codes
  let bankAccountCodes = [];
  let escrowBankAccountCodes = [];
  if (transfers && transfers.length > 0) {
    bankAccountCodes = [
      ...new Set(
        transfers.map(f => f?.sourceBankAccount?.institutionCode).filter(f => f)
      ),
    ];

    escrowBankAccountCodes = [
      ...new Set(
        transfers.map(f => f?.escrowBankAccount?.institutionCode).filter(f => f)
      ),
    ];
  }

  // combine them
  const allCodes = [...bankAccountCodes, ...escrowBankAccountCodes].map(m => {
    return {
      institutionCode: m,
    };
  });

  const { institutionsLogo } = useInstitutionLogoOR(
    size(allCodes) > 0 ? allCodes : []
  );

  const [showModal, setShow] = useState(false);
  const tenant = get(props, 'tenant');
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const nav = document.querySelector('.menu-nav-bar__grey-bar');
  if (!nav) window.location.reload();

  /**
   * @function
   */
  const alertBannerText = () => {
    if (transfers) {
      return `You Have ${
        transfers.filter(f => f.status === 'sent').length
      } Transfers Waiting for You!`;
    }
    return '';
  };

  /**
   * @function
   */
  const alertBannerShouldBeVisible = () => {
    if (transfers && transfers.length > 0) {
      return transfers.filter(f => f.status === 'sent').length > 0;
    }
    return false;
  };

  /**
   *
   * @param {*} history
   * @returns
   */
  const onClickMakeTransfer = history => {
    history.push('/create-account/step-select-account');
  };

  useEffect(() => {
    const transfersID = map(transfers, item => ({
      id: item.id,
      showMoreInfo: false,
    }));
    updateSeeMoreInfo(transfersID);
    refetchTransfers();
    if (get(props.location, 'state.editError')) {
      handleShow();
      props.location.state.editError = false;
    }
    // if (transfersNew && transfersArchive) {
    //   setTransfers([...transfersNew, ...transfersArchive]) 
    // }
    if (transfersNew ) {
      setTransfers([...transfersNew]) 
    }
    
  }, [clientID, props.location, refetchTransfers, transfersNew]);
  // }, [clientID, props.location, refetchTransfers, transfersNew, transfersArchive]);

  // if (loadingSearch || loadingSearchTransfer || loadingTransfersArchive) {
  if (loadingSearch || loadingSearchTransfer ) {
    return <SpinnerLoader />;
  } else {
    return (
      <>
        <ContentModal
          isVisible={showModal}
          onClose={handleClose}
          content={buildCancelEditError()}
          withoutButtons
          small
          hide
        />
  
        <BoxContainer withDoubleBorder withLogButton widest>
          <div className="transfer-history__line-container">
            <div className="transfer-history__title">Transfers</div>
            <div className="transfer-history__addicon">
              <PaymintsIconButton type="primary" size="large">
                <Link to="#" onClick={() => onClickMakeTransfer(props.history)}>
                  <i className="fa fa-plus" />
                </Link>
              </PaymintsIconButton>
            </div>
          </div>
  
          <AlertBanner
            alertType="warn"
            text={alertBannerText()}
            show={alertBannerShouldBeVisible()}
          />
          
          {transfers?.length > 0 ? (
            <>
              <MobileHistory
                transfers={transfers}
                seeMoreInfo={seeMoreInfo}
                updateSeeMoreInfo={updateSeeMoreInfo}
                institutionsLogo={institutionsLogo}
                clientDocuments={clientDocuments}
                tenant={tenant}
              />
              <TransferHistoryListing
                transfers={transfers}
                seeMoreInfo={seeMoreInfo}
                updateSeeMoreInfo={updateSeeMoreInfo}
                institutionsLogo={institutionsLogo}
                clientDocuments={clientDocuments}
                tenant={tenant}
                display={window.innerWidth < 600 ? false : true}
              />
            </>
          ) : (
            <p className="transfer-history__no-data">
              You have no pending or completed transfers, select the “+” button to
              start a transfer.
            </p>
          )}
        </BoxContainer>
      </>
    );
  }

  
};

export default withRouter(TransferHistory);
